<template>
  <div class="match-container">
    <el-card class="match-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>约战大厅</span>
        <el-button type="primary" style="float: right; padding: 3px 0" size="small">
          创建房间
        </el-button>
      </div>
      <div class="match-content">
        <h3>约战功能开发中...</h3>
        <p>敬请期待！</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Match'
}
</script>

<style scoped>
.match-container {
  padding: 20px 0;
}

.match-card {
  margin-bottom: 20px;
}

.match-content {
  text-align: center;
  padding: 50px 0;
}
</style>